import { useTranslation } from 'react-i18next';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, Tooltip } from '@mui/material';



export default function RHFPasswordTextField({ name, maxLength = null, length, hasNbHistoDiffPasswordError, isEqualToLogin, hasLengthNotValid, nbOldPassword, ...other }) {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const pattVerify = new RegExp(`^$|(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])`);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const isNotValid = !pattVerify?.test(field.value);
        const textTooltip = <>
          {isNotValid && <>*{t("errors.passwordRule1")} <br /></>}
          {isEqualToLogin && <>*{t("errors.passwordRule2")} <br /></>}
          {hasNbHistoDiffPasswordError && 
          <>
            {nbOldPassword !== "0" ?
              `*${t("errors.passwordRule3", { "nbOldPassword": nbOldPassword })}` :
              `*${t("errors.passwordRule5")}`}<br />
          </>}
          {hasLengthNotValid && <>*{t("errors.passwordRule4", { "length": length })}`</>}
        </>;

        return error ? <Tooltip placement="right" title={error.type === 'required' ? error.message : textTooltip}>
          <TextField
            {...field}
            fullWidth
            error={!!error}
            inputProps={{ maxLength }}
            {...other} />
        </Tooltip> : <TextField
          {...field}
          fullWidth
          error={false}
          inputProps={{ maxLength }}
          {...other} />;

      }}
    />
  );
}
